function devtricker_dom_get_emailLoginModal(){
    return document.getElementById('loginModal');
}

function devtricker_dom_focus_focusInEmailLoginInput() {
    var usernameInput = document.getElementById('login-form-username');
    usernameInput.focus();
}

function devtricker_dom_get_emailLoginForm() {
    return document.getElementById('loginForm');
}

function devtricker_dom_get_submitEmailLoginButton() {
    return document.getElementById('login-modal-email-button-enter');
}

function devtricker_dom_set_changeLoginEmailButtonToLoading() {

    const button = devtricker_dom_get_submitEmailLoginButton();

    button.setAttribute('disabled', 'true');
    button.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${g_devtricker_i18n.loading}`;
}

function devtricker_dom_set_changeLoginEmailButtonToGeneratingPow() {

    const button = devtricker_dom_get_submitEmailLoginButton();

    button.setAttribute('disabled', 'true');
    button.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Generating PoW...`;
}

function devtricker_dom_set_changeLoginEmailButtonToInitial() {

    const button = devtricker_dom_get_submitEmailLoginButton();

    button.removeAttribute('disabled');
    button.innerHTML = g_devtricker_i18n.login;
}

function devtricker_dom_set_clearEmailLoginError() {
    document.getElementById('loginError').style.display = 'none';
}

function devtricker_dom_set_printEmailLoginError(message = 'An error occurred. Please try again later.') {
    const e = document.getElementById('loginError');

    e.textContent = message;
    e.style.display = 'block';
}